import { render, staticRenderFns } from "./AruszallitoProduct.vue?vue&type=template&id=6a5ad61b&scoped=true&"
import script from "./AruszallitoProduct.vue?vue&type=script&lang=js&"
export * from "./AruszallitoProduct.vue?vue&type=script&lang=js&"
import style0 from "./AruszallitoProduct.vue?vue&type=style&index=0&id=6a5ad61b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5ad61b",
  null
  
)

export default component.exports